import { render, staticRenderFns } from "./FormsList.vue?vue&type=template&id=4103b3b6&scoped=true"
import script from "./FormsList.vue?vue&type=script&lang=js"
export * from "./FormsList.vue?vue&type=script&lang=js"
import style0 from "./FormsList.vue?vue&type=style&index=0&id=4103b3b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4103b3b6",
  null
  
)

export default component.exports